import React, { PropsWithChildren } from 'react'

import { CheckOutlinedIcon } from '../../../../icons/CheckOutlinedIcon'
import { RedXIcon } from '../../../../icons/RedXIcon'
import { useWindowResize } from '../../../../utils/domUtils'
import { CommonModalTitleProps, ModalProps } from '../types'
import { MessageModalDesktop } from './MessageModalDesktop'
import { MessageModalMobile } from './MessageModalMobile'

export interface MessageModalProps extends MessageModalBaseProps {
  icon: React.ReactNode
}

export const MessageModal: React.FC<MessageModalProps> = (props) => {
  const isMobile = useWindowResize()
  return isMobile ? <MessageModalMobile {...props} /> : <MessageModalDesktop {...props} />
}

interface MessageModalBaseProps extends PropsWithChildren<CommonModalTitleProps & ModalProps> {
  description?: React.ReactNode | string
  isLoading?: boolean
  onClose(): void
  onConfirm?(): void
  renderFooter?(props: MessageModalProps): React.ReactNode[]
  headerless?: boolean
}

export interface SuccessMessageModalProps extends MessageModalBaseProps {
  icon?: React.ReactNode
}

export const SuccessMessageModal: React.FC<SuccessMessageModalProps> = ({
  icon = <CheckOutlinedIcon size={64} />,
  ...props
}) => <MessageModal {...props} icon={icon} />

export const FailedMessageModal: React.FC<MessageModalBaseProps> = (props) => (
  <MessageModal {...props} icon={<RedXIcon size={64} />} />
)
